import { Injectable } from '@angular/core';
import { BaseService } from '../../../../core/base/base.service';
import { HttpClient } from '@angular/common/http';
import { LeaseTypeModel } from '../../../../core/models/lease-type.model';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LeaseTypeService extends BaseService<LeaseTypeModel> {
  defaultSort = 'technicalIdentifier';
  defaultSortOrder = 'asc';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'lease-type', authService);
  }

  checkDependencies(leaseTypeModel: LeaseTypeModel) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/checkDependencies/${leaseTypeModel._id}`, {});
  }

  // function called by a generic system, don't remove it :
  changeAndArchiveGeneric(_id: string, body: any) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndArchiveGeneric/${_id}`, body);
  }
}
